module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"searchSidebar\">\n            <table-search-sidebar></table-search-sidebar>\n        </div>\n        <div>\n            <div class=\"searchTable\" class=\"row-fluid\">\n                <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n            </div>\n        </div>\n    </div>\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/search/search.html
 ** module id = 632
 ** module chunks = 0
 **/